export const CACHE_NAME = "activity-log";
